import { useEffect, useState } from "react";
import { Syllabus } from "../../../../types/dataModel";
import { API } from "../../../../common/Constants";
import useFetch from "../../../../hooks/useFetch";
import PreLoader from "../../../../core/common/preLoader";
import { getAPIHeaders, isNotEmpty } from "../../../../common/Utils";
import { Link } from "react-router-dom";

interface Props {
  onSuccess: () => void;
}

const AddSyllabus = ({ onSuccess }: Props) => {
  const [syllabus, setSyllabus] = useState<Syllabus>();
  const [errorMessage, setErrorMessage] = useState<string | undefined>("");
  const { isLoading, error, data, status, callFetch } = useFetch();
  const [showMsgBox, setShowMsgBox] = useState<boolean>(false);

  useEffect(() => {
    if (data && status && status < 299) {
      reset();
      setShowMsgBox(true);
      onSuccess();
    }
  }, [status]);

  useEffect(() => {
    if (error) {
      if (error.response?.data) {
        setErrorMessage(error.response?.data);
      } else {
        setErrorMessage("Something went wrong please try again later.");
      }
    }
  }, [error]);

  const handleSubmit = (event: any) => {
    event.preventDefault();

    if (!isNotEmpty(syllabus?.title)) {
      setErrorMessage("Please provide title");
    } else if (!isNotEmpty(syllabus?.code)) {
      setErrorMessage("Please provide code");
    } else if (syllabus && !syllabus?.details) {
      syllabus.details = {};
    } else {
      setErrorMessage("");
      callFetch(API.SYLLABUS, "POST", getAPIHeaders(), null, {
        ...syllabus,
      });
    }
  };

  const reset = () => {
    setSyllabus({
      title: "",
      description: "",
      code: "",
      details: {},
    });
    setErrorMessage("");
    setShowMsgBox(false);
  };

  const renderForm = () => {
    return (
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Add Syllabus</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={reset}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={syllabus?.title}
                    onChange={(e) => {
                      setSyllabus({
                        ...syllabus,
                        title: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <input
                    type="text"
                    className="form-control"
                    value={syllabus?.description}
                    onChange={(e) => {
                      setSyllabus({
                        ...syllabus,
                        description: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Code <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={syllabus?.code}
                    onChange={(e) => {
                      setSyllabus({
                        ...syllabus,
                        code: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div style={{ maxWidth: "50%" }}>
              {errorMessage ? (
                <>
                  <i className="ti ti-alert-triangle text-danger" />
                  <span className="text-danger"> {errorMessage} </span>
                </>
              ) : (
                <></>
              )}
            </div>
            <div>
              <button
                type="button"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                onClick={reset}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Add Syllabus
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  };

  const renderMsgBox = () => {
    return (
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
            <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
              <i className="ti ti-thumb-up fs-36" />
            </span>
            <h4 className="mb-1">Add Syllabus Successfull</h4>
            <p className="mb-3">Syllabus is added successfully.</p>
            <div className="d-flex justify-content-center">
              <Link
                to="#"
                data-bs-dismiss="modal"
                className="btn btn-success"
                onClick={() => {
                  setTimeout(() => {
                    setShowMsgBox(false);
                  }, 1000);
                }}
              >
                Close
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="modal fade"
      id="add_syllabus"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <PreLoader showLoader={isLoading} />
        {showMsgBox ? renderMsgBox() : renderForm()}
      </div>
    </div>
  );
};

export default AddSyllabus;
